import { authorCourse, terrainPreset, type HolePlan } from './courseAuthoring';
import { plans } from './coursePlans';
export const royalHeatherMetadata = {
  id: 'royal-heather',
  name: 'Royal Heather',
  description:
    'A historic, understated heathland championship venue of rolling ground and exacting natural bunkers.',
  environmentPreset: 'heathland-overcast',
  metadata: {
    location: 'Surrey, England',
    regionType: 'historic heathland',
    difficulty: 91,
    typicalWind: [6, 21] as const,
    greenSpeed: [11, 12] as const,
    firmness: 'firm' as const,
    primaryChallenge: 'Placement, ground play, severe bunkers, sloped greens and patience',
    signatureHoles: [1, 8, 16, 18],
    tournamentEventId: 'event-9',
    previewTheme: 'royal-heather',
    environmentPalette: {
      fairway: '#657449',
      rough: '#796047',
      bunker: '#c4ab78',
      water: '#5d7370',
      haze: '#a5a79e',
    },
    vegetationStyle: 'purple heather and sparse mature Scots pine',
    terrainStyle: terrainPreset('heathland-rolls', 13, 125, 1.3).id,
  },
};
const pars = [4, 4, 3, 4, 4, 5, 4, 4, 3, 4, 4, 5, 3, 4, 4, 3, 4, 4];
const yards = [
  430, 410, 175, 455, 390, 545, 420, 310, 190, 435, 465, 530, 180, 405, 450, 210, 475, 465,
];
const names = [
  'Blind Crown',
  'Heather Bend',
  'Sand Hollow',
  'Old Road',
  'Gorse Line',
  'Long Heather',
  'Plateau',
  'Temptation',
  'Wind Dial',
  'Estate',
  'Deep Pots',
  'Homeward',
  'Punchbowl',
  'Ridge Run',
  'Patience',
  'Two Shot',
  'Long March',
  'Royal Diagonal',
];
const options: Partial<HolePlan>[] = [];
options[0] = { elevation: { tee: 0, landing: 14, green: 5 }, bunkerCount: 4 };
options[7] = {
  bunkerCount: 7,
  landingZones: [{ distance: 235, width: 55, preferredSide: 'right' }],
};
options[16] = { bunkerCount: 5, greenRadius: 14 };
options[17] = {
  dogleg: 'right',
  landingZones: [{ distance: 275, width: 36, preferredSide: 'left' }],
  bunkerCount: 5,
};
export const createRoyalHeatherDocument = () =>
  authorCourse({
    ...royalHeatherMetadata,
    plans: plans(names, pars, yards, options).map((p) => ({ ...p, trees: p.trees ?? 2 })),
  });
